import logo from "../assets/logo.png";

export default function Logo({ maxWidth = "170px", marginBottom = "1.5rem" }) {
  return (
    <img
      src={logo}
      alt="MailBox"
      style={{
        display: "block",
        width: "100%",
        maxWidth,
        height: "auto",
        marginBottom,
      }}
    />
  );
}
